import { createClient } from '@supabase/supabase-js'
import { Database } from './types'

const supabaseUrl = "https://bgtoeunhooapdpjkquag.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJndG9ldW5ob29hcGRwamtxdWFnIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTI3ODU2NzAsImV4cCI6MjAwODM2MTY3MH0.EucivIw46ZUdNai6xIxpdjzISdyvlDDx2BQlzy7ALW0"

export const supabase = createClient<Database>(
    supabaseUrl, supabaseAnonKey)